import type { ArrayElement } from "./type"

export const genJsonLdOrganization = (opt: {
  siteName: string
  siteURL: string
  siteSameURLs: string[]
}) => {
  return {
    "@context": "http://schema.org",
    "@type": "Organization",
    name: opt.siteName,
    url: opt.siteURL,
    sameAs: opt.siteSameURLs,
  }
}

export const genJsonLdArticlesContributor = (opt: {
  parsonIdentifier: string,
  parsonName: string,
}) => {
  return [
    {
      "@context": "http://schema.org",
      "@type": "ProfilePage",
      "mainEntity": {
        "@type": "Person",
        "identifier": opt.parsonIdentifier,
        "name": opt.parsonName,
      }
    },
  ]
}

export const genJsonLdArticle = (opt: {
  siteName: string
  siteURL: string
  article: {
    title: string
    imageURL: string
    datePublished: string
    dateModified: string
    authors: {
      name: string
      url: string
      jobTitle: string
      description: string
      imageURL: string
    }[]
  }
}) => {
  return {
    "@context": "http://schema.org",
    "@type": "Article",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": opt.siteURL,
    },
    headline: opt.article.title,
    image: [opt.article.imageURL],
    datePublished: opt.article.datePublished,
    dateModified: opt.article.dateModified,
    author: opt.article.authors.map(author => ({
      "@type": "Person",
      name: author.name,
      url: author.url,
      jobTitle: author.jobTitle,
      description: author.description,
      image: author.imageURL,
    })),
    publisher: {
      "@type": "Organization",
      name: opt.siteName,
      url: opt.siteURL,
    },
  }
}

export const genArticlesTopBreadcrumbs = () => {
  return [
    { name: "ホーム", url: "/" },
    { name: "コラム", url: "/media/column/" },
  ]
}
export const genArticlesCategoryBreadcrumbs = (category: {
  name: string | null
  slug: string | null
}) => {
  return [
    { name: "ホーム", url: "/" },
    { name: "コラム", url: "/media/column/" },
    {
      name: category.name!,
      url: `/media/column/category/${category.slug!}/`,
    },
  ]
}
export const genArticlesContributorBreadcrumbs = (contributor: ArrayElement<Queries.CreateListByContributorQuery["allContentfulContributor"]["nodes"]>) => {
  return [
    { name: "ホーム", url: "/" },
    { name: "コラム", url: "/media/column/" },
    {
      name: contributor.name!,
      url: `/media/column/contributor/${contributor.id}/`,
    },
  ]
}

export const genArticleBreadcrumbs = (opt: {
  article: {
    slug: string
    title: string
    typename: string
    category?: {
      name: string | null
      slug: string | null
    } | null
  }
}) => {
  const getURL = (slug: string, typename: string) => {
    switch (typename) {
      case "ContentfulArticle":
        return `/media/column/${slug}/`
      case "ContentfulArticleRecipe":
        return `/media/column/recipe/${slug}/`
      case "ContentfulArticleReport":
        return `/media/column/report/${slug}/`
      case "ContentfulArticleInterview":
        return `/media/column/interview/${slug}/`
      case "ContentfulArticleUserInterview":
        return `/media/column/user-interview/${slug}/`
      default:
        return ""
    }
  }
  if (!opt.article.category) {
    return [
      { name: "ホーム", url: "/" },
      { name: "コラム", url: "/media/column/" },
      {
        name: opt.article.title!,
        url: getURL(opt.article.slug, opt.article.typename),
      },
    ]
  }
  return [
    { name: "ホーム", url: "/" },
    { name: "コラム", url: "/media/column/" },
    {
      name: opt.article.category.name!,
      url: `/media/column/category/${opt.article.category.slug!}/`,
    },
    {
      name: opt.article.title!,
      url: getURL(opt.article.slug, opt.article.typename),
    },
  ]
}
